/**
 * Madde başlıkları "GRUP ADI: Alt Başlık" biçimindedir. Grup adı zaten yanında göründüğü için önek grup adıyla
 * eşleşirse yalnız alt başlık döner; eşleşmezse başlık olduğu gibi kalır, grup adında olmayan bilgi gizlenmez.
 */
export const stripGroupPrefix = (title, groupName) => {
  const separatorIndex = title.indexOf(':');
  if (separatorIndex === -1) return title;

  const normalize = (text) => text.trim().toLocaleUpperCase('tr');
  const prefix = title.slice(0, separatorIndex);
  if (normalize(prefix) !== normalize(groupName ?? '')) return title;

  return title.slice(separatorIndex + 1).trim() || title;
};
